import { render, staticRenderFns } from "./point_auction.vue?vue&type=template&id=6647c779&scoped=true"
import script from "./point_auction.vue?vue&type=script&lang=js"
export * from "./point_auction.vue?vue&type=script&lang=js"
import style0 from "./point_auction.vue?vue&type=style&index=0&id=6647c779&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6647c779",
  null
  
)

export default component.exports